// Extend the HTMLElement prototype
HTMLElement.prototype.updateHTMLContent = function (newContent) {
  Array.from(this.children).forEach((el) => el.remove());
  Array.from(this.childNodes).forEach((el) => el.remove());
  this.insertAdjacentHTML('beforeend', newContent);
};
class BuildBox extends HTMLElement {
  constructor() {
    super();
    this.steps = this.querySelector('.byob__steps');
    this.welcome = this.querySelector('.byob__welcome');
    this.welcomeTiers = this.querySelector('.byob__welcome-tiers');
    this.welcomeTitle = this.querySelector('.byob__welcome-title');
    this.welcomeSubtitle = this.querySelector('.byob__welcome-subtitle');
    this.welcomeSpinner = this.querySelector('.byob__welcome-spinner');
    this.tiersList = Array.from(this.welcomeTiers.querySelectorAll('.byob__welcome-tier'));
    this.bundleMain = this.querySelector('.byob__main');
    this.byobHeading = this.querySelector('.byob__headings ');
    this.welcomeBadge = this.querySelector('.byob__headings-badge');
    this.selection = [];
    this.initProductsPerPage = 0;
    this.currentPage = 1;
    this.productsPerPage = 9;
    this.endProductsPerPage = this.initProductsPerPage + this.productsPerPage;
    this.selectedAddOns = [];
    this.isFetching = false;
    this.filters = [];

    window.addEventListener('popstate', async (event) => {
      event?.state?.step && event?.state?.step == 0
        ? await this.render()
        : event?.state?.step == 1
        ? this.renderBundleBuilder()
        : await this.render();
    });

    document.body.addEventListener('click', (ev) => {
      setTimeout(() => {
        const filtersInput = this.querySelector('[name="active_filters"]');
        const filterLabel = this.querySelector('[for="active_filters"]');
        const overlayLayer = document.querySelector('.product__nutritional-information-overlay-layer.hidden');
        const inputHamper = document.querySelector('#byob__box');
        console.log(ev.target);
        if (
          filtersInput &&
          filtersInput.checked &&
          !ev.target.closest('.byob__filters') &&
          !ev.target.closest('[for="active_filters"]') &&
          ev.target !== filtersInput &&
          ev.target !== filterLabel &&
          ev.target !== filterLabel.nextElementSibling
        ) {
          filtersInput.checked = false;
          // dispatch the change event to trigger the filter
          filtersInput.dispatchEvent(new Event('change'));
        }
        if (ev.target == overlayLayer) {
          inputHamper.checked = false;
          inputHamper.dispatchEvent(new Event('change'));
        }
      }, 10);
    });
  }

  connectedCallback() {
    this.connect();
    this.money_format = document.querySelector('body').getAttribute('data-format');
    this.enableUpsell = false;
  }

  async connect() {
    this.init();
    const { currentHamper, selectedHamperStorage } = this.getStorageHamper();
    if (selectedHamperStorage && this.cart.items.length > 0) {
      const bundleItems = this.cart.items.filter(
        (item) => item.properties['_rc_bundle'] === selectedHamperStorage._rc_bundle
      );
      this.enableLoadingSpinner();
      this.products = await this.getProducts();
      this.selection = bundleItems.map((item) => {
        const product = this.products.find((p) => p.id == item.product_id);
        const variant = product ? product.variants.find((v) => v.id == item.variant_id) : false;
        return {
          product: product,
          variant: variant,
          quantity: item.quantity,
        };
      });
      this.handleSort();
      this.renderBundleBuilder();
    } else {
      if (!currentHamper || currentHamper?.properties?.inCart == false) {
        this.render();
        this.handleSort();
        if (this.rcBundle) {
          const bundleItems = this.cart.items.filter((item) => item.properties['_rc_bundle'] === this.rcBundle);
          if (bundleItems.length > 0) {
            const bundleProperties = bundleItems[0].properties;
            this.enableLoadingSpinner();
            this.tier = this.tiers.find((tier) => tier.price == bundleProperties['_tier']);
            this.selection = bundleItems.map((item) => {
              const product = this.getProducts().then((products) => products.find((p) => p.id == item.product_id));
              const variant = product ? product.variants.find((v) => v.id == item.variant_id) : false;
              return {
                product: product,
                variant: variant,
                quantity: item.quantity,
              };
            });
            this.bundleLocked = true;
            this.renderBundleBuilder();
            await this.ready();
            return;
          }
        }
      } else {
        this.selection = currentHamper?.properties?.selection || [];
        this.renderBundleBuilder();
      }
    }

    await this.addEventListeners();
    await this.ready();
    this.getProducts();
  }

  init() {
    this.urlParams = new URLSearchParams(window.location.search);
    this.rcBundle = this.urlParams.get('_rc_bundle');
    this.cart = JSON.parse(this.querySelector('#cart-json').innerHTML);
    this.plans = JSON.parse(this.querySelector('#plans-json').innerHTML);
    this.tiers = JSON.parse(this.dataset.tiers);
    this.variantsTitle = JSON.parse(this.dataset.variantsTitle);
    const hampersStorage =
      localStorage.getItem('hampers') && this.cart.items.length > 0
        ? JSON.parse(localStorage.getItem('hampers'))
        : null;
    //if (localStorage.getItem('hampers') && this.cart.items.length == 0) {
    //  localStorage.removeItem('hampers');
    //}
    if (this.tiers) {
      //this.tiers.sort((a, b) => a.price - b.price);
      !hampersStorage
        ? (this.tier = this.tiers[0])
        : (this.tier = this.tiers[parseInt(hampersStorage[0].properties.tierIndex)]);
    }
    this.tierVariance = 300;
    this.productIds = JSON.parse(this.dataset.products);
    this.discounts = JSON.parse(this.dataset.discounts);
    this.view = 'welcome';
  }

  async getProducts() {
    if (this.products) return this.products;
    await this.getBundle();
    this.products = Object.keys(this.bundle.collections).reduce((accumulator, key) => {
      const collection = this.bundle.collections[key];
      collection.products.forEach((product) => {
        const existingProduct = accumulator.find((p) => p.id == product.id);

        if (!existingProduct) {
          // If the product doesn't exist in the accumulator, create a new one with an array to store collection IDs.
          product.collectionIds = [key];
          accumulator.push(product);
        } else {
          // If the product already exists, add the collection ID to its 'collectionIds' array.
          existingProduct.collectionIds.push(key);
        }
      });
      return accumulator;
    }, []);
    return this.products;
  }

  async getBundle() {
    if (this.bundle) return this.bundle;
    const bundle = await fetch(`/tools/recurring/bundle-data/${this.productIds[0]}`).then((req) => req.json());
    console.log('bundle', bundle);
    this.bundle = bundle;
    return bundle;
  }

  async changeView(ev) {
    switch (ev.target.dataset.viewIndex) {
      case 0:
      case '0':
        this.rcBundle = false;
        await this.render();
        await this.addEventListeners();
        await this.ready();

        break;
      case 1:
      case '1':
        this.bundleLocked = true;
        this.renderBundleBuilder();
        break;
    }
    const index = parseInt(ev.target.dataset.viewIndex);
    document.body.classList.toggle('page-type--plan', index == 0);
    document.body.classList.toggle('page-type--selection', index == 1);
    window.requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }

  //step 1
  async render() {
    this.handleUrl(0);
    this.bundleMain.classList.add('step-disable');
    this.welcome.classList.remove('step-disable');
    this.welcomeSpinner.classList.add('step-disable');
    this.welcomeTitle?.classList.remove('no-visible');
    this.welcomeSubtitle?.classList.remove('no-visible');
    this.byobHeading?.classList.remove('no-visible');
    this.welcomeTiers?.classList.remove('no-visible');
    this.welcomeBadge.classList.remove('step-disable');
    this.renderSteps(0);
    //this.welcomeTiers.updateHTMLContent(this.renderTiers();

    this.querySelectorAll('.byob__step [data-action="view:change"]').forEach((el) => {
      el.addEventListener('click', this.changeView.bind(this));
    });
  }
  handleSort() {
    window.requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
    });
  }
  renderSteps(activeIndex) {
    const steps = this.steps.querySelectorAll('.byob__step');
    steps.forEach((step, index) => {
      const stepClasses =
        activeIndex > index ? 'byob__step--complete' : activeIndex === index ? 'byob__step--active' : '';
      stepClasses && step?.classList.add(stepClasses);
      const stepButton = step.querySelector('button'),
        stepText = step.querySelector('.byob__step-text');
      if (activeIndex > index) {
        stepButton.classList.remove('step-disable');
        stepText.classList.add('step-disable');
      } else {
        stepButton.classList.add('step-disable');
        stepText.classList.remove('step-disable');
      }
    });

    document.body.classList.toggle('page-type--plan', activeIndex == 0);
    document.body.classList.toggle('page-type--selection', activeIndex == 1);
  }

  enableLoadingSpinner() {
    this.welcome.classList.add('step-disable');
    this.welcomeTitle?.classList.add('no-visible');
    this.welcomeSubtitle?.classList.add('no-visible');
    this.byobHeading?.classList.remove('no-visible');
    this.welcomeTiers?.classList.add('no-visible');
    this.welcomeBadge.classList.add('step-disable');

    this.welcomeSpinner.classList.remove('no-visible');
    this.bundleMain.classList.remove('step-disable');
  }

  async renderBundleBuilder(ev) {
    this.enableLoadingSpinner();

    this.handleUrl(1);
    this.byobHeading?.classList.remove('no-visible');
    const { currentHamper, selectedHamperStorage } = this.getStorageHamper();
    if (this.bundleLocked) {
      this.bundleLocked = false;
    } else {
      const tierIndex = selectedHamperStorage
        ? this.tiers.findIndex((tier) => tier.price == selectedHamperStorage.tier_price)
        : currentHamper
        ? currentHamper?.properties?.tierIndex
        : ev?.target?.value || 0;
      this.tier = selectedHamperStorage
        ? this.tiers[this.tiers.findIndex((tier) => tier.price == selectedHamperStorage.tier_price)]
        : currentHamper
        ? this.tiers[parseInt(currentHamper?.properties?.tierIndex)]
        : this.tiers[tierIndex];

      //localstorage hamper object, creation
      const hampers = new Array();
      const hamper = {
        _rc_bundle: selectedHamperStorage ? selectedHamperStorage._rc_bundle : '',
        properties: {
          tierIndex,
          sellingPlanId: selectedHamperStorage ? selectedHamperStorage.sellingPlanId : '',
          tier: this.tier,
          selection: this.selection,
          inCart: selectedHamperStorage ? true : false,
        },
      };
      hampers.push(hamper);
      !localStorage.getItem('hampers') && localStorage.setItem('hampers', JSON.stringify(hampers));
    }
    const nextTier = this.getNextObject([...this.tiers], this.tier); // ... send a dupicate of the array so you dont modify the original
    const previousTier = this.getPreviousObject([...this.tiers], this.tier); // ... send a dupicate of the array so you dont modify the original
    this.view = 'bundle';
    this.view == 'bundle' && this.welcome.classList.add('step-disable');

    await this.getProducts();
    this.bundleMain.updateHTMLContent(`
      <div class="byob__content">
        ${this.renderFilters()}
        ${this.renderSorting()}
        <div class="byob__products">${await this.renderProducts()}</div>
        <!-- <div class="load-more-btn"></div> -->
      </div>
      <aside class="byob__box">
        <input id="byob__box" type="checkbox"/>
        <label for="byob__box"></label>
        <form>
          ${this.renderBox(this.tier)}
        </form>
        <div class="byob__box--layer hidden"></div>
      </aside>`);
    this.welcomeSpinner.classList.add('no-visible');
    this.bundleMain.classList.remove('no-visible');

    this.querySelector('[data-ref="box:upgrade"]').addEventListener('click', this.upgradeBox.bind(this));
    this.querySelector('[data-ref="box:downgrade"]').addEventListener('click', this.downgradeBox.bind(this));

    this.renderSteps(1);
    this.querySelectorAll('.byob__step [data-action="view:change"]').forEach((el) => {
      el.addEventListener('click', this.changeView.bind(this));
    });
    this.querySelectorAll('[data-ref="box:tier"]').forEach((el) => {
      el.updateHTMLContent(`${Shopify.formatMoney(this.tier.price, this.money_format).replace('.00', '')}`);
    });
    document.querySelectorAll('byob-quantity').forEach((el) => {
      el.addEventListener('change', this.handleSelectionChange.bind(this));
    });
    if (nextTier) {
      this.querySelectorAll('[data-ref="box:next-tier"]').forEach((el) => {
        /*el.updateHTMLContent(
          `Upgrade to ${Shopify.formatMoney(nextTier.price, this.money_format).replace('.00', '')} hamper`
        );*/
      });
    }
    if (previousTier) {
      this.querySelectorAll('[data-ref="box:previous-tier"]').forEach((el) => {
        /* el.updateHTMLContent(
          `Downgrade to ${Shopify.formatMoney(previousTier.price, this.money_format).replace('.00', '')} hamper`
        );*/
      });
    }

    this.querySelector('.byob__products').addEventListener('submit', this.handleSelection.bind(this));
    this.querySelector('.byob__box form').addEventListener('submit', this.handleSubmit.bind(this));
    this.querySelectorAll('.byob__filters button').forEach((filterButton) => {
      filterButton.addEventListener('click', this.handleFilter.bind(this));
    });
    this.selection = [...this.selection];
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (window.matchMedia('(max-width: 800px)').matches) {
      this.handleOpenHamper();
    }
  }
  handleOpenHamper() {
    const inputHamper = document.querySelector('#byob__box');
    const asideBox = document.querySelector('aside.byob__box');
    const overlayLayer = document.querySelector('.product__nutritional-information-overlay-layer');
    const asideOverlay = document.querySelector('.byob__box--layer');
    const sellingPlans = document.querySelector('.byob__info--wrapper .byob__info--plans');
    const byobHeading = document.querySelector('.byob__headings-container');
    byobHeading.appendChild(sellingPlans);
    inputHamper.addEventListener('change', function () {
      console.log(inputHamper.checked);
      if (inputHamper.checked) {
        asideBox.style.zIndex = 1150;
        overlayLayer.classList.remove('hidden');
        asideOverlay.classList.remove('hidden');
      } else {
        asideBox.style.zIndex = 0;
        overlayLayer.classList.add('hidden');
        asideOverlay.classList.add('hidden');
      }
    });
  }
  handleUrl(index) {
    window.localStorage.setItem('step', index);
    const currentUrl = new URL(location);
    const step = this.handleParam(index);
    currentUrl.searchParams.set('step', step);
    window.history.pushState({ step: index }, step, currentUrl);
    const hampersStorage = localStorage.getItem('hampers');
    const stepStorage = localStorage.getItem('step');
    const selectedHamperStorage = localStorage.getItem('selectedHamper');

    if (index == 0) {
      this.selection = [];

      hampersStorage ? localStorage.removeItem('hampers') : null;
      stepStorage ? localStorage.removeItem('step') : null;
      selectedHamperStorage ? localStorage.removeItem('selectedHamper') : null;
    }
  }
  handleParam(index) {
    const steps = this.steps.querySelectorAll('.byob__step');
    const step = steps[index]
      .querySelector('.byob__step-text')
      .textContent.toLowerCase()
      .replace(/ /g, '_')
      .replace(/[^a-z0-9_]/g, '');
    return step;
  }
  getNextObject(arr, currentObject) {
    // Find the index of the currentObject in the array
    const sortedArray = arr.sort((a, b) => a.price - b.price); // sort the array to find  the correct index according to the price
    const currentIndex = sortedArray.indexOf(currentObject);
    const isLastObject = currentIndex === sortedArray.length - 1;

    if (isLastObject) {
      return false;
    } else if (currentIndex !== -1) {
      // Check if the currentObject exists in the array
      // Calculate the index of the next object
      const nextIndex = (currentIndex + 1) % sortedArray.length;

      // Return the next object
      return sortedArray[nextIndex];
    } else {
      // Handle the case when the currentObject is not in the array
      console.error('Current object not found in the array');
      return null;
    }
  }
  getPreviousObject(arr, currentObject) {
    // Find the index of the currentObject in the array
    const sortedArray = arr.sort((a, b) => a.price - b.price); // sort the array to find  the correct index according to the price
    const currentIndex = sortedArray.indexOf(currentObject);
    const isLastObject = currentIndex === sortedArray.length - 1;
    const isFirstObject = currentIndex === 0;

    if (isFirstObject) {
      return false;
    } else if (currentIndex !== -1) {
      // Check if the currentObject exists in the array
      // Calculate the index of the next object
      const previousIndex = (currentIndex - 1) % sortedArray.length;

      // Return the next object
      return sortedArray[previousIndex];
    } else {
      // Handle the case when the currentObject is not in the array
      console.error('Current object not found in the array');
      return null;
    }
  }

  upgradeBox(ev) {
    ev.preventDefault();
    const nextTier = this.getNextObject([...this.tiers], this.tier); // ... send a dupicate of the array so you dont modify the original
    if (nextTier) {
      this.tier = nextTier;

      if (this.view !== 'welcome') {
        this.querySelectorAll('[data-ref="box:tier"]').forEach((el) => {
          el.updateHTMLContent(`${Shopify.formatMoney(this.tier.price, this.money_format).replace('.00', '')}`);
        });
      }

      this.handleHamperStorage('tier', this.tier);
      this.handleHamperStorage('tierIndex', `${this.tiers.indexOf(this.tier)}`);
      this.updateBox(this.selection);
    }
  }
  downgradeBox(ev) {
    const previousTier = this.getPreviousObject([...this.tiers], this.tier); // ... send a dupicate of the array so you dont modify the original
    if (previousTier) {
      this.tier = previousTier;

      if (this.view !== 'welcome') {
        this.querySelectorAll('[data-ref="box:tier"]').forEach((el) => {
          el.updateHTMLContent(`${Shopify.formatMoney(this.tier.price, this.money_format).replace('.00', '')}`);
        });
      }

      this.handleHamperStorage('tier', this.tier);
      this.handleHamperStorage('tierIndex', `${this.tiers.indexOf(this.tier)}`);
      this.updateBox(this.selection);
    }
  }

  renderFilters() {
    const filterIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5.28 4.56047C4.64 4.66714 4.09333 4.9338 3.64 5.36047C3.18667 5.78714 2.85333 6.2938 2.64 6.88047L2.56 7.20047H0V8.72047H2.56L2.64 9.12047C2.85333 9.70714 3.2 10.2138 3.68 10.6405C4.16 11.0671 4.72 11.3338 5.36 11.4405C5.73333 11.4938 6.14667 11.4805 6.6 11.4005C7.05333 11.3205 7.48 11.1471 7.88 10.8805C8.28 10.6138 8.61333 10.2938 8.88 9.92047C9.14667 9.54714 9.30667 9.20047 9.36 8.88047V8.72047H18V7.20047H9.36V7.12047C9.30667 6.90714 9.2 6.6538 9.04 6.36047C8.88 6.06714 8.69333 5.8138 8.48 5.60047C8.05333 5.12047 7.52 4.80047 6.88 4.64047C6.72 4.58714 6.45333 4.54714 6.08 4.52047C5.70667 4.4938 5.44 4.50714 5.28 4.56047ZM6.32 6.00047C6.74667 6.10714 7.10667 6.30714 7.4 6.60047C7.69333 6.8938 7.86667 7.2538 7.92 7.68047C8.02667 8.26714 7.88 8.80047 7.48 9.28047C7.08 9.76047 6.56 10.0005 5.92 10.0005C5.44 10.0005 5.01333 9.84047 4.64 9.52047C4.26667 9.20047 4.05333 8.80047 4 8.32047C3.89333 7.62714 4.08 7.04047 4.56 6.56047C5.04 6.08047 5.62667 5.8938 6.32 6.00047ZM11.28 12.5605C10.64 12.6671 10.0933 12.9338 9.64 13.3605C9.18667 13.7871 8.85333 14.2938 8.64 14.8805L8.56 15.2005H0V16.7205H8.56L8.64 17.1205C8.85333 17.7071 9.2 18.2138 9.68 18.6405C10.16 19.0671 10.72 19.3338 11.36 19.4405C11.7867 19.4938 12.1867 19.4938 12.56 19.4405C13.2 19.3338 13.76 19.0671 14.24 18.6405C14.72 18.2138 15.0667 17.7071 15.28 17.1205L15.36 16.7205H18V15.2005H15.36V15.1205C15.3067 14.9071 15.2 14.6538 15.04 14.3605C14.88 14.0671 14.6933 13.8138 14.48 13.6005C14.0533 13.1205 13.52 12.8005 12.88 12.6405C12.72 12.5871 12.4533 12.5471 12.08 12.5205C11.7067 12.4938 11.44 12.5071 11.28 12.5605ZM12.32 14.0005C12.7467 14.1071 13.1067 14.3071 13.4 14.6005C13.6933 14.8938 13.8667 15.2538 13.92 15.6805C14.0267 16.2671 13.88 16.8005 13.48 17.2805C13.08 17.7605 12.56 18.0005 11.92 18.0005C11.44 18.0005 11.0133 17.8405 10.64 17.5205C10.2667 17.2005 10.0533 16.8005 10 16.3205C9.89333 15.6271 10.08 15.0405 10.56 14.5605C11.04 14.0805 11.6267 13.8938 12.32 14.0005Z" fill="#235C55"/>
          </svg>`;
    const filterArrow = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="10" viewBox="0 0 17 10" fill="none">
        <path d="M1 1L8.21368 9L15.4274 1" stroke="#005759" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    const filterExit = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M1 1L14 14" stroke="#767676"/>
        <path d="M14 1L0.999999 14" stroke="#767676"/>
        </svg>`;
    // const filters = ['Beef', 'Chicken', 'Pork', 'Turkey', 'Fish', 'Rice', 'Snacks', 'Veg', 'Prepped Pots', 'Protien Pizza', 'Meal Kits', 'Breakfast', 'Condiments'];
    // ${filters.map(filter => {
    return `
      <h3 class="byob__main-header">Select your products</h3>
      <input type="checkbox" hidden name="active_filters" id="active_filters" class="byob__filters-input">
      <label for="active_filters" class="byob__filters-label"><span>${filterIcon}</span> Filter <span>${filterArrow}</span></label>
      <div class="byob__filters">
        <div class="byob__filters-heading">
          <label for="active_filters" class="byob__filters-exit">${filterExit}</label>
          <button type="button" value="clear" class="byob__filters-clear">Clear all</button>
          <h2>Filter</h2>
        </div>      
        ${Object.keys(this.bundle.collections)
          .map((key) => {
            const collection = this.bundle.collections[key];
            return `<button type="button" value="${collection.id}">${collection.title.replace('BYOB', '')}</button>`;
          })
          .join('')}
          <label for="active_filters" class="byob__filters-submit">View Products</label>
      </div>
      `;
  }

  renderSorting() {
    return ``;
  }

  async renderProducts() {
    // Initialize an empty string to store the HTML
    this.products = await this.getProducts();
    let htmlString = '';
    for (let i = 0; i < this.products.length; i++) {
      const product = this.products[i];
      const variantHtml = [];
      product.variants.forEach((variant, variantIndex) => {
        // Calculate the incremental index
        const incrementalIndex = i * product.variants.length + variantIndex + 1;
        variantHtml.push(this.renderProductsVariant(variant, product, incrementalIndex));
      });
      htmlString += i === 0 ? variantHtml.join('') : variantHtml.join('');
    }
    return htmlString;
  }

  renderProductsVariant(variant, product, index) {
    const { currentHamper } = this.getStorageHamper();
    const storageVariantID =
      currentHamper?.properties?.inCart == true
        ? this.selection.find((selection) => selection.variant.id == variant.id)
        : null;
    let currentVariant = storageVariantID ? storageVariantID.variant : variant;
    let currentProduct = storageVariantID ? storageVariantID.product : product;

    const variantInCart = storageVariantID ? true : false;

    const featuredImage = currentVariant.featured_image
      ? currentVariant.featured_image.src
      : currentProduct.images
      ? currentProduct.images[0]
      : ``;

    const variantPrice = this.discounts[currentVariant.id] || currentVariant.price;
    const variantSKU = currentVariant.sku || '';
    const comparePrice = currentVariant.compare_at_price;
    // const reviewsIoskuString = currentProduct.variants.map((currentVariant) => currentVariant.sku).join(';');
    const trustPilotSkuString = currentProduct.variants
      .map((currentVariant) => currentVariant.sku || 'TRUSTPILOT_SKU_VALUE_' + currentVariant.id)
      .join(',');
    const starIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
    <path d="M8.05179 0.145627L9.59682 5.03948C9.62379 5.12666 9.7047 5.1861 9.79332 5.1861H14.7945C14.9948 5.1861 15.0757 5.44764 14.9139 5.57048L10.8683 8.59397C10.7951 8.64945 10.7643 8.74455 10.7951 8.83173L12.3401 13.7256C12.4018 13.9198 12.186 14.0822 12.0242 13.9633L7.97858 10.9399C7.90538 10.8844 7.80905 10.8844 7.73585 10.9399L3.69025 13.9633C3.52842 14.0822 3.31266 13.9198 3.37431 13.7256L4.91934 8.83173C4.94631 8.74455 4.91934 8.64945 4.84613 8.59397L0.800532 5.57048C0.638708 5.4516 0.723472 5.1861 0.919972 5.1861H5.92111C6.00973 5.1861 6.09064 5.12666 6.11761 5.03948L7.66264 0.145627C7.72429 -0.0485423 7.99399 -0.0485423 8.05564 0.145627H8.05179Z" fill="#FFD140"/>
  </svg>`;
    const productTitle =
      this.variantsTitle[currentVariant.id] ||
      `${currentProduct.title}${
        currentVariant.title && !currentVariant.title.toLowerCase().includes('default')
          ? ` - ${currentVariant.title}`
          : ''
      }`;

    return `
    <form
      class="byob__product ${currentProduct.collectionIds
        .map((collectionId) => `box-product__collection--${collectionId}`)
        .join(' ')}
        ${variantInCart && 'in-basket'}
        "
      data-product-id="${currentProduct.id}"
      data-variant-id="${currentVariant.id}"
    >
      <img src="${this.imageUrl(featuredImage, 210, 210)}" loading="lazy"/>
      <build-box-info data-product="${currentProduct.handle}" data-variant="${currentVariant.id}"></build-box-info>
      <p class="byob__product-title">${productTitle}</p>
      <div class="byob__product-price-wrapper">${
        comparePrice
          ? '<span class="byob__product-compare-price">' +
            Shopify.formatMoney(comparePrice, this.money_format) +
            '</span>'
          : ''
      }
      <span class="byob__product-price">${Shopify.formatMoney(variantPrice, this.money_format)}</span>   
    </div>
       
      <div class="byob__product-info">
        ${
          currentVariant.available
            ? `<span class="byob__product-stock byob__product-stock--available">In Stock</span>`
            : `<span class="byob__product-stock byob__product-stock--unavailable">Out of Stock</span>`
        }
      </div>
      <build-box-reviews data-provider="trustpilot" data-sku="${trustPilotSkuString}" data-variant-sku="${variantSKU}">
        <div>
        ${starIcon}${starIcon}${starIcon}${starIcon}${starIcon}
        </div>
        <h3>10 Reviews</h3>
      </build-box-reviews>
      <div class="byob__product-form">
        ${
          currentVariant.available
            ? `
        <byob-quantity class="${!variantInCart ? 'step-disable' : ''}">
          <input
            type="number"
            name="quantity"
            data-index="${index}"
            data-variant="${currentVariant.id}"
            step="${currentVariant.quantity_rule.increment || '1'}"
            value="${storageVariantID ? storageVariantID.quantity : currentVariant.quantity_rule.min || '0'}"
            min="${currentVariant.quantity_rule.min || '0'}"
            ${currentVariant.quantity_rule.max ? ` max="${currentVariant.quantity_rule.max}"` : ''}
          />
        </byob-quantity>
          `
            : ''
        }
        <button ${!currentVariant.available ? `disabled` : ''} ${
      variantInCart ? `disabled` : ''
    } class="button button-reversed ${variantInCart ? `button-disabled` : ''} ">${
      currentVariant.available ? (variantInCart ? 'In basket' : `Add to basket`) : `Sold out`
    }</button>
      </div>
    </form>
    `;
  }

  renderBox(tier) {
    const { currentHamper } = this.getStorageHamper();
    return `
    <div class="byob__info--wrapper"> 
    <h3 class="byob__info--title"><span class="dark-text">Your</span> <span data-ref="box:tier">${Shopify.formatMoney(
      tier.price,
      this.money_format
    ).replace('.00', '')}</span> hamper</h3>
    <div class="byob__info--plans">
    <label>Delivery frequency</label>
    <select name="selling_plan">
      <option value="">One delivery only</option>
      ${this.plans
        .map(
          (plan) =>
            `<option value="${plan.id}" ${
              plan.id == parseInt(currentHamper?.properties?.sellingPlanId) ? 'selected' : ''
            }>${plan.name}</option>`
        )
        .join('')}
    </select>
    </div>
    <ul class="byob__selection" data-ref="box:selection"></ul>
    </div>
    <div class="byob__box-footer">
      <div class="byob__box-totals">
        <p class="byob__box-total"><span>Total</span> <span data-ref="box:total">£0.00</span></p>
        <p class="byob__box-count"><span data-ref="box:count">0</span> <span>items</span></p>
      </div>
      <p class="byob__box-credit"><span>Remaining credit</span> <span data-ref="box:credit">£0.00</span><label for="byob__box" class="view_hamper--label">View hamper</label></p>
      <progress data-ref="box:progress" value="0" min="0" max="100"></progress>
      <div class="buttons-wrapper">
      <button  disabled data-ref="box:downgrade" type="button" class="button button-clear" style="display:none;"><svg class="down" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#FFA031"></circle><path d="M15.2305 26.3076L24.9229 17.392L15.2305 9.69223" stroke="white" stroke-width="3" stroke-linecap="round" fill="none"></path></svg><span data-ref="box:previous-tier">Downgrade</span></button>
      <button  data-ref="box:upgrade" type="button" class="button button-clear"><svg class="up" viewBox="0 0 36 36"><circle cx="18" cy="18" r="18" fill="#FFA031"></circle><path d="M15.2305 26.3076L24.9229 17.392L15.2305 9.69223" stroke="white" stroke-width="3" stroke-linecap="round" fill="none"></path></svg><span data-ref="box:next-tier">Upgrade</span></button>
      
      <button disabled data-ref="box:submit" class="button button-reversed product-form--atc-button">
      <span class="atc-button--text">${this.rcBundle ? `Update box in basket` : `Add to basket`}
      </span>
      <span class="atc-button--icon">
      <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill-rule="nonzero" fill="currentColor">
        <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-3.852a9.148 9.148 0 1 0 0-18.296 9.148 9.148 0 0 0 0 18.296z" opacity=".29"/><path d="M13 26c7.18 0 13-5.82 13-13a1.926 1.926 0 0 0-3.852 0A9.148 9.148 0 0 1 13 22.148 1.926 1.926 0 0 0 13 26z"/>
      </g>
    </svg>
      </span>
      </button>
      </div>
    </div>
    `;
  }

  renderAddOns() {
    return this.addOnCollection.products
      .map((product, productIndex) => {
        return product.variants
          .map((variant, variantIndex) => {
            // Calculate the incremental index
            const incrementalIndex = productIndex * product.variants.length + variantIndex + 1;
            return this.renderAddOnProductsVariant(variant, product, incrementalIndex);
          })
          .join('');
      })
      .join('');
  }

  imageUrl(imageUrl, width = null, height = null) {
    // Check if either width or height is provided
    if (!imageUrl) return '';
    if (width !== null || height !== null) {
      // Check if the URL already contains query parameters
      const separator = imageUrl.includes('?') ? '&' : '?';

      // Append width and/or height as query parameters if provided
      const params = [];
      if (width !== null) {
        params.push(`width=${width}`);
      }
      if (height !== null) {
        params.push(`height=${height}`);
      }

      const modifiedUrl = `${imageUrl}${separator}${params.join('&')}`;
      return modifiedUrl;
    }

    // If neither width nor height is provided, return the original URL
    return imageUrl;
  }

  renderAddOnProductsVariant(variant, product, index) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const featuredImage = variant.featured_image
      ? variant.featured_image.src
      : product.images
      ? product.images[0].src
      : ``;
    const variantPrice = variant.price;
    return `
    <form
      class="byob__product"
      data-product-id="${product.id}"
      data-variant-id="${variant.id}"
    >
      <img src="${this.imageUrl(featuredImage, 210, 210)}" loading="lazy"/>
      <span class="byob__product-price">${Shopify.formatMoney(variantPrice, this.money_format)}</span>
      <p class="byob__product-title">${product.title}${
      variant.title && !variant.title.toLowerCase().includes('default') ? ` - ${variant.title}` : ''
    }</p>      
      <div class="byob__product-info">
        ${
          variant.available
            ? `<span class="byob__product-stock byob__product-stock--available">In Stock</span>`
            : `<span class="byob__product-stock byob__product-stock--unavailable">Out of Stock</span>`
        }
        <build-box-info data-product="${product.handle}" data-variant="${variant.id}"></build-box-info>
      </div>
      <div class="byob__product-form">
        ${
          variant.available
            ? `
        <byob-quantity>
          <input
            type="number"
            name="quantity"
            value="1"
            min="1"
          />
        </byob-quantity>
          `
            : ''
        }
        <button${!variant.available ? ` disabled` : ''} class="button button-reversed">${
      variant.available ? `Add to basket` : `Sold out`
    }</button>
      </div>
    </form>
    `;
  }
  async addEventListeners() {
    this.querySelectorAll('.byob__welcome-tier button').forEach((filterButton) => {
      filterButton.addEventListener('click', this.renderBundleBuilder.bind(this));
    });
    this.querySelectorAll('.byob__welcome-tier img').forEach((filterImg) => {
      filterImg.addEventListener('click', function () {
        filterImg.parentElement.querySelector('button').dispatchEvent(new Event('click'));
      });
    });
  }

  async ready() {
    this.selection = [...this.selection];
  }

  handleFilter(ev) {
    const value = ev.target.value;

    // Clone the current filters array to avoid modifying the original array
    const currentFilters = [...this.filters];

    if (currentFilters.includes(value)) {
      // Value is already in the filters array, so remove it
      const updatedFilters = currentFilters.filter((filter) => filter !== value);
      this.filters = updatedFilters;
    } else {
      // Value is not in the filters array, so add it
      currentFilters.push(value);
      this.filters = currentFilters;
    }
  }

  get filters() {
    return this._filters;
  }

  set filters(newFilters) {
    if (this._filters !== newFilters) {
      this._filters = newFilters;
      this.updateFilters(this._filters);
    } else {
      console.log('Filters are the same');
    }
  }

  updateFilters(filters) {
    const allFilters = this.querySelectorAll('.byob__filters button');
    allFilters.forEach((element) => {
      element.classList.toggle('active', filters ? filters.includes(element.value) : false);
    });
    // Update active state on buttons

    const classes = filters.map((collectionId) => `.box-product__collection--${collectionId}`).join(', ');
    // Add the hidden class to other elements
    const allProducts = this.querySelectorAll('.byob__products .byob__product');
    allProducts.forEach((element) => {
      element.classList.toggle('hidden', classes == '' ? false : !element.matches(classes));
    });
  }

  handleSelection(ev) {
    ev.preventDefault();
    const formData = new FormData(ev.target);
    const el = ev.target;
    const products = this.view === 'bundle' ? this.products : this.addOnCollection.products;
    const product = products.find((p) => p.id == el.dataset.productId);
    const variant = product ? product.variants.find((v) => v.id == el.dataset.variantId) : false;

    let selection = this.view === 'bundle' ? this.selection : this.selectedAddOns;

    // Find an existing item in the selection with the same product and variant
    const existingItemIndex = selection.findIndex(
      (item) => item.product.id == el.dataset.productId && item.variant.id == el.dataset.variantId
    );

    if (existingItemIndex !== -1) {
      // If an item with the same product and variant is found, increment its quantity
      selection[existingItemIndex].quantity =
        parseInt(selection[existingItemIndex].quantity) + parseInt(formData.get('quantity'));
    } else {
      const item = {
        product: product,
        variant: variant,
        quantity: formData.get('quantity'),
      };
      selection = [...selection, item];
    }

    // Update the global property if needed (assumes 'selection' and 'selectedAddOns' are properties of the class or component)
    if (this.view === 'bundle') {
      this.selection = [];
      this.selection = selection;
    } else {
      this.selectedAddOns = [];
      this.selectedAddOns = selection;
    }
    this.updateProduct(variant.id);
    this.handleHamperStorage('selection', this.selection);
  }

  renderSelection(input = null) {
    let selection = input || this.selection;
    return selection
      .map((item, index) => {
        const variant = item.variant;
        const product = item.product;
        const variantPrice = this.discounts[variant.id] || variant.price;
        const quantity = parseInt(item.quantity);

        // <input type="hidden" name="selections[${index}]['quantity']" readonly value="${item.quantity}"/>
        return `
        <li data-product="${product.id}" data-variant="${variant.id}">
          <input type="hidden" name="selections[${index}]['collectionId']" disabled/>
          <input type="hidden" name="selections[${index}]['product']" readonly value="${product.id}"/>
          <input type="hidden" name="selections[${index}]['variant']" readonly value="${variant.id}"/>
          <div class="byob__item-image">
            <img src="${product.featured_image}" loading="lazy"/>
            <span>${quantity}</span>
          </div>
          <div>
            <p class="byob__item-title">${product.title}${
          variant.title && !variant.title.toLowerCase().includes('default') ? ` - ${variant.title}` : ''
        }</p>
            <byob-quantity>
              <input
                type="number"
                name="selections[${index}]['quantity']"
                data-index="${index}"
                data-product="${product.id}"
                data-variant="${variant.id}"
                step="${variant.quantity_rule.increment || '1'}"
                value="${quantity}"
                min="${variant.quantity_rule.min || '0'}"
                ${variant.quantity_rule.max ? ` max="${variant.quantity_rule.max}"` : ''}
              />
            </byob-quantity>
          </div>
          <span class="byob__item-price">${Shopify.formatMoney(variantPrice * quantity, this.money_format)}</span>
          <button class="byob__item-remove" type="button" data-ref="item:remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.0879 5L9.77474 1.31316L8.68688 0.225302L5.00004 3.91214L1.3132 0.225302L0.225342 1.31316L3.91218 5L0.225342 8.68684L1.3132 9.7747L5.00004 6.08786L8.68688 9.7747L9.77474 8.68684L6.0879 5Z" fill="#1D1D1D"/</svg>
          </button>
        </li>
      `;
      })
      .join('');
  }

  renderAddOnsSelection(input = null) {
    let selectedAddOns = input || this.selectedAddOns;
    return selectedAddOns
      .map((item, index) => {
        const variant = item.variant;
        const product = item.product;
        const variantPrice = variant.price * 100;
        const quantity = parseInt(item.quantity);
        const featuredImage = variant.featured_image
          ? variant.featured_image.src
          : product.images
          ? product.images[0].src
          : ``;
        return `
        <li data-product="${product.id}" data-variant="${variant.id}">
          <input type="hidden" name="selections[${index}]['collectionId']" disabled/>
          <input type="hidden" name="selections[${index}]['product']" readonly value="${product.id}"/>
          <input type="hidden" name="selections[${index}]['variant']" readonly value="${variant.id}"/>
          <input type="hidden" name="selections[${index}]['quantity']" readonly value="${item.quantity}"/>
          <div class="byob__item-image"> 
          <img src="${this.imageUrl(featuredImage, 64, 64)}}" loading="lazy"/>
            <span>${quantity}</span>
          </div>
          <p class="byob__item-title">${product.title}${
          variant.title && !variant.title.toLowerCase().includes('default') ? ` - ${variant.title}` : ''
        }</p>
          <span class="byob__item-price">${Shopify.formatMoney(variantPrice * quantity, this.money_format)}</span>
          <button class="byob__item-remove" type="button" data-ref="item:remove">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.0879 5L9.77474 1.31316L8.68688 0.225302L5.00004 3.91214L1.3132 0.225302L0.225342 1.31316L3.91218 5L0.225342 8.68684L1.3132 9.7747L5.00004 6.08786L8.68688 9.7747L9.77474 8.68684L6.0879 5Z" fill="#1D1D1D"/</svg>
          </button>
        </li>
      `;
      })
      .join('');
  }

  async handleSubmit(ev) {
    ev.preventDefault();
    const submitElement = ev.submitter;
    submitElement?.classList.add('processing');
    if (this.enableUpsell && this.view === 'bundle' && !this.rcBundle) {
      this.view = 'addOns';
      const { totalQuantity, totalPrice } = this.selection.reduce(
        (accumulated, item) => {
          const variant = item.variant;
          const variantPrice = this.discounts[variant.id] || variant.price;
          const quantity = parseInt(item.quantity);

          accumulated.totalQuantity += quantity;
          accumulated.totalPrice += variantPrice * quantity;

          return accumulated;
        },
        { totalQuantity: 0, totalPrice: 0 }
      );

      let currentTier = this.tiers[0];
      for (let i = 0; i < this.tiers.length; i++) {
        currentTier = this.tiers[i];
        if (totalPrice <= this.tiers[i].price) break;
      }

      const submitElement = this.querySelector('.byob__box [data-ref="box:submit"]');
      this.addOnCollection = await fetch('/collections/add-ons/products.json').then((data) => data.json());
      this.querySelector('.byob__products').updateHTMLContent(this.renderAddOns());

      const upgradeElement = this.querySelector('.byob__box [data-ref="box:upgrade"]');
      if (upgradeElement) upgradeElement.disabled = true;

      this.querySelector('.byob__filters').remove();
      this.querySelector('.byob__main-header').updateHTMLContent(`
        <p>Missing something from your box?</p>
        <h3>Choose your <span>Add-Ons</span></h3>
        <p>We've hand-picked a selection of lean meats, snacks and store cupboard essentials we think you'll love. You can select as many or as few as you'd like to add to your order (this won't effect your box).</p>
      `);
      this.querySelector('[data-ref="box:steps"]').updateHTMLContent(this.renderSteps(2));
      this.querySelectorAll('.byob__step [data-action="view:change"]').forEach((el) => {
        el.addEventListener('click', this.changeView.bind(this));
      });

      const selectionElement = this.querySelector('.byob__box [data-ref="box:selection"]');
      selectionElement.updateHTMLContent(`
      <li class="">
        <div class="byob__item-image">
          <img src="${this.bundle.variants[0].image}" loading="lazy"/>
        </div>
        <div>
          <p class="byob__item-title">Build your own ${Shopify.formatMoney(
            currentTier.price,
            this.money_format
          ).replace('.00', '')} Hampers</p>
          <button data-action="view:bundle">Edit</button>
          <details>
            <summary><span>Includes</span><svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 5L4.70732 2L1 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></summary>
            <ul>
            ${this.selection.map((item, index) => {
              const variant = item.variant;
              const product = item.product;

              return `<li>${product.title}${
                variant.title && !variant.title.toLowerCase().includes('default') ? ` - ${variant.title}` : ''
              }</li>`;
            })}
            </ul>
          </details>
        </div>
        <span class="byob__item-price">${Shopify.formatMoney(currentTier.price, this.money_format).replace(
          '.00',
          ''
        )}</span>
      </li>
      <h4>Your <span>add ons</span></h4>
      <ul class="byob__addon-selection" data-ref="box:addOns"></ul>
      `);

      submitElement.textContent = `Review & Checkout`;

      this.querySelectorAll('button[data-action="view:bundle"]').forEach((el) => {
        el.addEventListener('click', this.renderBundleBuilder.bind(this));
      });
    } else {
      const sellingPlanId = this.querySelector('[name="selling_plan"]')?.value;
      let sellingPlanIndex;
      const sellingPlan = sellingPlanId
        ? this.plans.find((plan, index) => {
            if (parseInt(plan.id) === parseInt(sellingPlanId)) {
              sellingPlanIndex = index;
              return true;
            }
          })
        : null;
      this.handleHamperStorage('sellingPlanId', sellingPlanId);
      if (this.rcBundle) {
        const bundleItems = this.cart.items.filter((item) => item.properties['_rc_bundle'] === this.rcBundle);
        const updates = bundleItems.reduce((acc, item) => {
          acc[item.key] = 0;
          return acc;
        }, {});

        await fetch(window.Shopify.routes.root + 'cart/update.js?', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        });
      }
      const selections = this.selection.map((item) => {
        // console.log(item.variant.selling_plan_allocations[0].selling_plan_id);
        const selection = {
          collectionId: item.product.collectionIds[0],
          externalProductId: item.product.id,
          externalVariantId: item.variant.id,
          quantity: `${item.quantity}`,
        };
        if (sellingPlan) {
          // const itemSellingPlanGroup = item.product.selling_plan_groups.find(
          //   (group) => group.options[0].name === sellingPlan.options[0].name
          // );
          // selection.sellingPlan = parseInt(sellingPlan.id);
          selection.sellingPlan = parseInt(item.variant.selling_plan_allocations[sellingPlanIndex].selling_plan_id);
        }
        return selection;
      });
      const bundle = {
        externalProductId: this.bundle.id, // Bundle's Shopify Product ID
        externalVariantId: this.bundle.variants[0].id, // Bundle's Shopify Variant ID
        selections: selections,
      };

      const { totalQuantity, totalPrice } = this.selection.reduce(
        (accumulated, item) => {
          const variant = item.variant;
          const variantPrice = this.discounts[variant.id] || variant.price;
          const quantity = parseInt(item.quantity);

          accumulated.totalQuantity += quantity;
          accumulated.totalPrice += variantPrice * quantity;

          return accumulated;
        },
        { totalQuantity: 0, totalPrice: 0 }
      );

      const cartItems = recharge.bundle.getDynamicBundleItems(bundle, this.bundle.handle);
      for (let i = 0; i < cartItems.length; i++) {
        // cartItems[i].properties['_tier'] = `Your ${Shopify.formatMoney(currentTier.price, this.money_format).replace('.00', '')} box`;
        cartItems[i].properties['_tier'] = this.tier.price;
        cartItems[i].properties['_plan'] = sellingPlanId;
        cartItems[i].properties['_rc_bundle_price'] = totalPrice;
      }

      const addOns = this.selectedAddOns.map((item) => {
        return {
          id: item.variant.id,
          quantity: item.quantity,
        };
      });

      const cartData = { items: cartItems.concat(addOns) };
      this.handleHamperStorage('_rc_bundle', cartData.items[0].properties['_rc_bundle']);
      const { currentHamper } = this.getStorageHamper();
      if (currentHamper?.properties?.inCart) {
        try {
          const resp = await fetch(window.Shopify.routes.root + 'cart.js');
          const { items } = await resp.json();
          const deleteItems = items.filter((item) => item.properties['_rc_bundle'] == currentHamper?._rc_bundle);
          const deleteItemsSameBundle = deleteItems.map((item) => ({ id: item.id, quantity: '0' }));
          const updates = deleteItemsSameBundle.reduce((obj, item) => {
            obj[item.id] = parseInt(item.quantity); // Convertir quantity a un número entero
            return obj;
          }, {});
          if (deleteItemsSameBundle) {
            try {
              const resp = await fetch(window.Shopify.routes.root + `cart/update.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates }),
              });
              try {
                await fetch(window.Shopify.routes.root + `cart/add.js`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(cartData),
                });
                this.handleHamperStorage('inCart', true);
                window.location.href = '/cart';
              } catch (error) {
                console.log(error);
              }
            } catch (error) {
              console.log(error);
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          await fetch(window.Shopify.routes.root + `cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartData),
          });
          this.handleHamperStorage('inCart', true);
          window.location.href = '/cart';
        } catch (error) {
          console.log(error);
        }
      }

      // return;
    }
  }

  get selection() {
    return this._selection;
  }

  set selection(newSelection) {
    if (this._selection !== newSelection) {
      this._selection = newSelection;
      this.updateBox(this._selection);
    }
  }

  get selectedAddOns() {
    return this._selectedAddOns;
  }

  set selectedAddOns(newSelectedAddOns) {
    if (this._selectedAddOns !== newSelectedAddOns) {
      this._selectedAddOns = newSelectedAddOns;
      this.updateAddOns(this._selectedAddOns);
    }
  }

  updateAddOns(selection) {
    const selectionElement = this.querySelector('.byob__box [data-ref="box:addOns"]');
    if (selectionElement) {
      selectionElement.updateHTMLContent(this.renderAddOnsSelection(selection));
      selectionElement.querySelectorAll('button[data-ref="item:remove"]').forEach((el) => {
        el.addEventListener('click', this.handleAddOnRemove.bind(this));
      });
    }
  }

  updateBox(selection) {
    const progreessElement = this.querySelector('.byob__box [data-ref="box:progress"]');
    const creditElement = this.querySelector('.byob__box [data-ref="box:credit"]');
    const submitElement = this.querySelector('.byob__box [data-ref="box:submit"]');
    const upgradeElement = this.querySelector('.byob__box [data-ref="box:upgrade"]');
    const downgradeElement = this.querySelector('.byob__box [data-ref="box:downgrade"]');
    const selectionElement = this.querySelector('.byob__box [data-ref="box:selection"]');
    const countElement = this.querySelector('.byob__box [data-ref="box:count"]');
    const totalElement = this.querySelector('.byob__box [data-ref="box:total"]');

    const { totalQuantity, totalPrice } = selection.reduce(
      (accumulated, item) => {
        const variant = item.variant;
        const variantPrice = this.discounts[variant.id] || variant.price;
        const quantity = parseInt(item.quantity);

        accumulated.totalQuantity += quantity;
        accumulated.totalPrice += variantPrice * quantity;

        return accumulated;
      },
      { totalQuantity: 0, totalPrice: 0 }
    );

    if (!this.tiers) return;

    // let currentTier = this.tiers[0].price;
    // for (let i = 0; i < this.tiers.length; i++) {
    //   currentTier = this.tiers[i].price;
    //   if (totalPrice <= this.tiers[i].price) break;
    // }

    // if (this.view !== 'welcome') {
    //   this.querySelectorAll('[data-ref="box:tier"]').forEach(el => {
    //     el.updateHTMLContent(`${Shopify.formatMoney(this.tier.price, this.money_format).replace('.00', '')} box`;
    //   });
    // }

    const tierLowerLimit = this.tier.price - this.tierVariance;
    const tierUpperLimit = this.tier.price + this.tierVariance;
    const remainingCredit = Math.max(0, this.tier.price - totalPrice);

    if (progreessElement) {
      progreessElement.max = this.tier.price;
      progreessElement.value = totalPrice;
    }

    if (creditElement) creditElement.updateHTMLContent(Shopify.formatMoney(remainingCredit, this.money_format));
    if (countElement) countElement.textContent = totalQuantity;
    if (totalElement) totalElement.textContent = Shopify.formatMoney(totalPrice, this.money_format);
    if (selectionElement) {
      selectionElement.updateHTMLContent(this.renderSelection(selection));
      selectionElement.querySelectorAll('button[data-ref="item:remove"]').forEach((el) => {
        el.addEventListener('click', this.handleRemove.bind(this));
      });
      selectionElement.querySelectorAll('byob-quantity').forEach((el) => {
        el.addEventListener('change', this.handleSelectionChange.bind(this));
      });
    }
    // if (submitElement) submitElement.disabled = totalQuantity == 0;
    // si totalprice supera nextier.lowerlimit recomendar siguente tier
    if (submitElement) {
      submitElement.disabled = !(totalPrice >= tierLowerLimit && totalPrice <= tierUpperLimit);
    }
    const nextTier = this.getNextObject([...this.tiers], this.tier); //... send a dupicate of the array so you dont modify the original
    const previousTier = this.getPreviousObject([...this.tiers], this.tier); //... send a dupicate of the array so you dont modify the original
    if (upgradeElement) {
      if (totalPrice >= nextTier.price - this.tierVariance) {
        // check if total price value is higher then next tier
        const newNextTier = this.getNextObject([...this.tiers], nextTier); // upgrade next tier
        upgradeElement.disabled = !(newNextTier && totalPrice >= tierLowerLimit);
        /*upgradeElement.updateHTMLContent(
          `Upgrade to ${Shopify.formatMoney(newNextTier.price, this.money_format).replace('.00', '')} hamper`
        );*/
      } else {
        //upgradeElement.disabled = !(nextTier && totalPrice >= tierLowerLimit); ///MP
        upgradeElement.disabled = !(nextTier) ///MP
        /*upgradeElement.updateHTMLContent(
          `Upgrade to ${Shopify.formatMoney(nextTier.price, this.money_format).replace('.00', '')} hamper`
        );*/
      }
    }
    if (downgradeElement) {
      //downgradeElement.disabled = !(previousTier && totalPrice <= tierLowerLimit); ///MP
      downgradeElement.disabled = true;//!(previousTier) ///MP
      /*downgradeElement.updateHTMLContent(
        `Downgrade to ${Shopify.formatMoney(previousTier.price, this.money_format).replace('.00', '')} hamper`
      );*/
    }
  }

  handleSelectionChange(ev) {
    //const index = parseInt(ev.target.dataset.index);
    const variant = ev.target.dataset.variant;
    const selectedItem = this.selection.find((item) => item.variant.id == variant);
    if (parseInt(ev.target.value) == 0) {
      // delete the item from the selection
      const deletedItem = this.selection.filter((item) => item.variant.id != variant);
      this.selection = deletedItem;

      // set value to 1 , so the submit button has a valid value, not 0
      ev.target.value = '1';
    } else if (selectedItem) {
      selectedItem['quantity'] = parseInt(ev.target.value);
      this.selection = [...this.selection];
    }

    try {
      this.handleHamperStorage('selection', this.selection);
    } catch (error) {
      console.log('handleHamperStorage error:', error);
    }
    this.updateProduct(variant);
  }

  handleRemove(ev) {
    const itemElement = ev.target.closest('li');
    const productID = itemElement.dataset.product;
    const variantID = itemElement.dataset.variant;

    // Find the index of the item in the selection array
    const itemIndex = this.selection.findIndex((item) => item.product.id == productID && item.variant.id == variantID);

    if (itemIndex !== -1) {
      // Remove the item from the selection array
      this.selection.splice(itemIndex, 1);
      this.selection = [...this.selection];
    }
    this.updateProduct(variantID);
    this.handleHamperStorage('selection', this.selection);
  }

  handleAddOnRemove(ev) {
    const itemElement = ev.target.closest('li');
    const productID = itemElement.dataset.product;
    const variantID = itemElement.dataset.variant;

    // Find the index of the item in the selection array
    const itemIndex = this.selectedAddOns.findIndex(
      (item) => item.product.id == productID && item.variant.id == variantID
    );

    if (itemIndex !== -1) {
      // Remove the item from the selection array
      this.selectedAddOns.splice(itemIndex, 1);
      this.selectedAddOns = [...this.selectedAddOns];
    }
  }
  updateProduct(id) {
    const foundProduct = this.selection.find(
      (prod) => parseInt(prod.variant.id) === parseInt(id) && parseInt(prod.quantity) > 0
    );
    const boxProduct = this.querySelector(`form[data-variant-id="${id}"]`);
    if (foundProduct) {
      const prodForm = this.querySelector(`[data-variant-id="${foundProduct.variant.id}"]`);
      const quantityBox = prodForm.querySelector('byob-quantity');

      const input = quantityBox.querySelector(`input[data-variant="${id}"]`);
      const button = prodForm.querySelector('.button.button-reversed');
      input.value = foundProduct.quantity;
      prodForm.classList.add('in-basket');
      button.textContent = 'In Basket';
      button.disabled = true;
      button.classList.add('button-disabled');
      quantityBox.classList.remove('step-disable');
    } else if (boxProduct) {
      const quantityBox = boxProduct.querySelector('byob-quantity');
      const button = boxProduct.querySelector('.button.button-reversed');
      button.textContent = 'Add to basket';
      boxProduct.classList.remove('in-basket');
      button.disabled = false;
      button.classList.remove('button-disabled');
      quantityBox.classList.add('step-disable');
      quantityBox.querySelector('input').value = 1;
    }
  }

  handleHamperStorage(property, value) {
    let { currentHamper, hampersStorage, hamperIndex } = this.getStorageHamper();
    const newHamper =
      property == '_rc_bundle'
        ? { ...currentHamper, [property]: value }
        : {
            ...currentHamper,
            properties: { ...currentHamper?.properties, [property]: value },
          };
    let newHampersStorage = [...hampersStorage];
    newHampersStorage[hamperIndex] = newHamper;
    if (!currentHamper?.properties?.inCart) {
      localStorage.setItem('hampers', JSON.stringify(newHampersStorage));
    } else {
      const editHamper = JSON.parse(localStorage.getItem('editHamper')) || currentHamper;
      if (property == '_rc_bundle') {
        localStorage.setItem('editHamper', JSON.stringify({ ...editHamper, [property]: value }));
      } else {
        localStorage.setItem(
          'editHamper',
          JSON.stringify({ ...editHamper, properties: { ...editHamper.properties, [property]: value } })
        );
      }

      if (property === 'inCart' && value) {
        localStorage.removeItem('hampers');
        localStorage.removeItem('editHamper');
        localStorage.removeItem('selectedHamper');
        localStorage.removeItem('step');
      }
    }
  }

  getStorageHamper() {
    const hampersStorage = JSON.parse(localStorage.getItem('hampers')) || [];
    const selectedHamperStorage = localStorage.getItem('selectedHamper')
      ? JSON.parse(localStorage.getItem('selectedHamper'))
      : null;

    const hamperIndex =
      hampersStorage.length > 0
        ? selectedHamperStorage
          ? hampersStorage.findIndex((hamper) => hamper._rc_bundle === selectedHamperStorage._rc_bundle)
          : 0
        : 0;

    const currentHamper = hampersStorage[hamperIndex] ? hampersStorage[hamperIndex] : null;
    return {
      hampersStorage,
      currentHamper,
      hamperIndex,
      selectedHamperStorage,
    };
  }
}
customElements.define('build-box', BuildBox);

class BuildBoxInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.connect();
  }

  async connect() {
    await this.addEventListeners();
  }

  async addEventListeners() {
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { root: null, threshold: 0.1 });
    this.observer.observe(this);
  }

  // Function to handle the intersection changes
  handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        fetch(`/products/${this.dataset.product}?variant=${this.dataset.variant}&view=nutrition`)
          .then((data) => data.text())
          .then((html) => this.updateHTMLContent(html));
        observer.unobserve(entry.target); // Stop observing once the element is visible
      }
    });
  }
}
customElements.define('build-box-info', BuildBoxInfo);

class AbstractReviewsProvider {
  constructor(sku) {
    if (new.target === AbstractReviewsProvider) {
      throw new TypeError('Cannot construct AbstractReviewsProvider instances directly');
    }
    this.sku = sku;
  }

  async getHtml() {
    throw new Error('getHtml method must be implemented');
  }

  postHtmlUpdateAction() {
    // Optional method to run after the HTML has been updated
  }
}

class ReviewsIoProvider extends AbstractReviewsProvider {
  async getHtml() {
    const response = await fetch(`https://api.reviews.io/product/review?store=musclefood.com&sku=${this.sku}`);
    const json = await response.json();
    const roundedAverage = Math.round(Number(json.stats?.average));
    const roundedCount = Math.round(Number(json?.stats?.count));
    const starIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                      <path d="M8.05179 0.145627L9.59682 5.03948C9.62379 5.12666 9.7047 5.1861 9.79332 5.1861H14.7945C14.9948 5.1861 15.0757 5.44764 14.9139 5.57048L10.8683 8.59397C10.7951 8.64945 10.7643 8.74455 10.7951 8.83173L12.3401 13.7256C12.4018 13.9198 12.186 14.0822 12.0242 13.9633L7.97858 10.9399C7.90538 10.8844 7.80905 10.8844 7.73585 10.9399L3.69025 13.9633C3.52842 14.0822 3.31266 13.9198 3.37431 13.7256L4.91934 8.83173C4.94631 8.74455 4.91934 8.64945 4.84613 8.59397L0.800532 5.57048C0.638708 5.4516 0.723472 5.1861 0.919972 5.1861H5.92111C6.00973 5.1861 6.09064 5.12666 6.11761 5.03948L7.66264 0.145627C7.72429 -0.0485423 7.99399 -0.0485423 8.05564 0.145627H8.05179Z" fill="#FFD140"/>
                    </svg>`;
    const starsString = roundedAverage ? starIcon.repeat(roundedAverage) : starIcon.repeat(0);
    return !isNaN(roundedCount) ? `<div>${starsString}</div><h3>${roundedCount} Reviews</h3>` : ``;
  }
}

class TrustpilotProvider extends AbstractReviewsProvider {
  getWidgetClassName() {
    return `tp-product-mini-${this.sku.replace(',', '-')}`;
  }

  async getHtml() {
    return `<div class="trustpilot-widget ${this.getWidgetClassName()}" data-locale="en-GB" data-template-id="54d39695764ea907c0f34825" data-businessunit-id="503c9e9b00006400051a33cc" data-style-height="24px" data-style-width="100%" data-sku="${
      this.sku
    }" data-no-reviews="hide" data-scroll-to-list="false" data-style-alignment="center">
      <a href="https://uk.trustpilot.com/review/musclefood.com" target="_blank" rel="noopener">Trustpilot</a>
    </div>`;
  }

  postHtmlUpdateAction() {
    if (window.Trustpilot) {
      document.querySelectorAll(`.${this.getWidgetClassName()}`).forEach((widget) => {
        Trustpilot.loadFromElement(widget);
      });
    }
  }
}

class BuildBoxReviews extends HTMLElement {
  constructor() {
    super();
    this.provider = this.createProvider(this.dataset.provider, this.dataset.sku);
  }

  connectedCallback() {
    this.connect();
  }

  async connect() {
    await this.addEventListeners();
  }

  async addEventListeners() {
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), { root: null, threshold: 0.1 });
    this.observer.observe(this);
  }

  createProvider(provider, sku) {
    switch (provider) {
      case 'reviews.io':
        return new ReviewsIoProvider(sku);
      case 'trustpilot':
        return new TrustpilotProvider(sku);
      default:
        throw new Error(`Unknown provider: ${provider}`);
    }
  }

  // Function to handle the intersection changes
  handleIntersection(entries, observer) {
    entries.forEach(async (entry) => {
      if (entry.isIntersecting) {
        this.updateHTMLContent(await this.provider.getHtml());
        this.provider.postHtmlUpdateAction();
        observer.unobserve(entry.target); // Stop observing once the element is visible
      }
    });
  }
}
customElements.define('build-box-reviews', BuildBoxReviews);

class BuildBoxQuantity extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.connect();
  }

  async connect() {
    await this.init();
    await this.render();
    await this.addEventListeners();
    await this.ready();
  }

  async init() {
    this.input = this.querySelector('input');
    this.step = 1;
    this.min = 1;
    this.max = 2;
  }
  async render() {
    this.insertAdjacentHTML(
      'afterbegin',
      `<button type="button" data-action="stepDowm"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" fill="none"><path fill="#104060" d="M10 0H0v2h10V0Z"/></svg></button>`
    );
    this.insertAdjacentHTML(
      'beforeend',
      `<button type="button" data-action="stepUp"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><g class="layer"><path fill="#104060" fill-rule="evenodd" d="M4 6v4h2V6h4V4H6V0H4v4H0v2h4z" clip-rule="evenodd"/></g></svg></button>`
    );
  }
  async addEventListeners() {
    this.querySelector('[data-action="stepUp"]').addEventListener('click', this.clickHandler.bind(this), false);
    this.querySelector('[data-action="stepDowm"]').addEventListener('click', this.clickHandler.bind(this), false);
  }
  async ready() {}

  clickHandler(ev) {
    ev.preventDefault();
    const variant = this.input.dataset.variant;
    const value = this.input.value;

    if (ev.currentTarget.dataset.action === 'stepUp') {
      this.input.stepUp();
    } else {
      if (this.input.value == '1') {
        // By changing the value, automatically dispatch the 'change' event,and tha handleSelectionChange function
        this.input.value = '0';
      } else {
        this.input.stepDown();
      }
    }
    if (value != this.input.value) {
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    document.querySelectorAll(`input[data-variant="${variant}"]`).forEach((input) => (input.value = this.input.value));
  }
}
customElements.define('byob-quantity', BuildBoxQuantity);
